/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The four formulas give a range of a few kilograms.`)
};

const es_iw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las cuatro fórmulas dan un rango de unos pocos kilogramos.`)
};

const de_iw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die vier Formeln ergeben eine Spanne von wenigen Kilogramm.`)
};

const nl_iw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De vier formules geven een bandbreedte van een paar kilo.`)
};

const fr_iw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les quatre formules donnent une fourchette de quelques kilogrammes.`)
};

const it_iw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le quattro formule danno un intervallo di alcuni chilogrammi.`)
};

const pt_br2_iw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As quatro fórmulas dão uma faixa de alguns quilos.`)
};

const pt_iw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As quatro fórmulas dão um intervalo de alguns quilogramas.`)
};

const ja_iw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4つの計算式は数キログラムの幅を示します。`)
};

const zh_iw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`四种公式给出的结果相差几公斤。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iw_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iw_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iw_ex2", locale)
	if (locale === "en") return en_iw_ex2(inputs)
	if (locale === "es") return es_iw_ex2(inputs)
	if (locale === "de") return de_iw_ex2(inputs)
	if (locale === "nl") return nl_iw_ex2(inputs)
	if (locale === "fr") return fr_iw_ex2(inputs)
	if (locale === "it") return it_iw_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_iw_ex2(inputs)
	if (locale === "pt") return pt_iw_ex2(inputs)
	if (locale === "ja") return ja_iw_ex2(inputs)
	return zh_iw_ex2(inputs)
};